import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
  makeStyles,
} from "@material-ui/core";
import SubjectIcon from "@material-ui/icons/Subject";
import CloseIcon from "@material-ui/icons/Close";

import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  // Fica dentro da bolha, mas visualmente separado: o auditor nunca pode
  // confundir transcrição com texto que a pessoa realmente digitou.
  wrapper: {
    margin: "2px 6px 0",
    padding: "4px 6px",
    borderRadius: 4,
    backgroundColor: "rgba(0, 0, 0, 0.035)",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 4,
  },
  label: {
    fontSize: 11,
    fontStyle: "italic",
    color: "#667781",
  },
  botao: {
    padding: 2,
  },
  icone: {
    fontSize: 16,
    color: "#667781",
  },
  // Trecho: as primeiras linhas bastam para o auditor decidir se precisa abrir.
  trecho: {
    fontSize: 13,
    fontStyle: "italic",
    color: "#3b3b3b",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    "@media print": {
      // No PDF não existe "clicar para ver mais": imprime tudo.
      display: "block",
      WebkitLineClamp: "unset",
      overflow: "visible",
    },
  },
  completa: {
    fontSize: 14,
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    lineHeight: 1.6,
  },
  tituloDialogo: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
}));

/**
 * Transcrição de uma mensagem de áudio.
 *
 * Mostra as primeiras linhas e um ícone que abre o texto inteiro. Áudio é onde
 * a venda costuma se decidir — preço, diagnóstico e acordo quase sempre vêm
 * falados — e sem isto a conversa fica ilegível para quem audita e para quem
 * assume o atendimento no lugar de outra pessoa.
 */
const AudioTranscription = ({ transcription }) => {
  const classes = useStyles();
  const [aberto, setAberto] = useState(false);

  if (!transcription) return null;

  const rotulo = i18n.t("audioTranscription.label");
  // Só oferece "ver completa" quando há mais do que cabe no trecho.
  const longa =
    transcription.length > 180 || transcription.split("\n").length > 3;

  return (
    <>
      <div className={classes.wrapper}>
        <div className={classes.header}>
          <span className={classes.label}>{rotulo}</span>
          {longa && (
            <Tooltip title={i18n.t("audioTranscription.seeFull")}>
              <IconButton
                size="small"
                className={classes.botao}
                onClick={() => setAberto(true)}
                aria-label={i18n.t("audioTranscription.seeFull")}
              >
                <SubjectIcon className={classes.icone} />
              </IconButton>
            </Tooltip>
          )}
        </div>
        <div className={classes.trecho}>{transcription}</div>
      </div>

      <Dialog
        open={aberto}
        onClose={() => setAberto(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle disableTypography className={classes.tituloDialogo}>
          <span>{rotulo}</span>
          <IconButton size="small" onClick={() => setAberto(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <div className={classes.completa}>{transcription}</div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AudioTranscription;
